import { useSelect } from '@wordpress/data';
import { store as editorStore } from '@wordpress/editor';

/**
 * A component that only renders its children if the current post type is in the allowed list.
 *
 * @param {Object}          props                  The component props
 * @param {string[]}        props.allowedPostTypes The post types to allow
 * @param {React.ReactNode} props.children         The children to render
 *
 * @return {React.ReactNode}
 */
function PostTypeCheck({ allowedPostTypes, children }) {
  const currentPostType = useSelect((select) => select(editorStore).getCurrentPostType(), []);

  if (!allowedPostTypes) {
    return null;
  }

  if (!allowedPostTypes.includes(currentPostType)) {
    return null;
  }

  return children;
}

export default PostTypeCheck;
